import { analytics } from '~entrypoints/analytics';
import isEmailAddress from '~Utils/is-email-address';

export default ({ sdk, leadSource }) => ({
  init() {
    this.sdk = sdk;
    this.leadSource = leadSource;
    this.userEmail = null;

    // SUBMITTED FIELDS
    this.email = '';
    this.name = '';
    this.token = '';
    this.sourceSystem = '';
  },

  install() {
    const buttonId = this.$refs['paypal-buttons'].id;

    this.sdk
      .Buttons({
        style: {
          shape: 'pill',
          tagline: false,
          // layout:  'horizontal',
          // color:   'blue',
          // label:   'paypal'
        },

        onClick: function () {
          let giftCheckbox = document.getElementById('is-gift-purchase');

          if (giftCheckbox.checked) {
            let userEmailField = document.getElementById('user-email');

            if (!isEmailAddress(userEmailField.value)) {
              userEmailField.classList.add('is-error');
              document.getElementById('user-email-error').setAttribute('x-show', 'true');
              return false;
            } else {
              this.userEmail = userEmailField.value;
            }
          }
        },

        createOrder: async (_data, actions) => {
          return actions.order.create(this.formatOrderData());
        },

        onApprove: async (_data, actions) => {
          const response = await actions.order.authorize();

          const { authorizationId, email, firstName, lastName } =
            this.parseAuthorizationResponse(response);

          this.email = email;
          document.getElementById('subscription_subscriber_email').value = this.email;

          this.token = authorizationId;

          this.name = [firstName, lastName].join(' ');
          document.getElementById('subscription_purchaser_name').value = this.name;

          this.sourceSystem = 'PayPal';

          await this.$nextTick();

          document.querySelectorAll('.plan_ids').forEach((field) => {
            if (!field.disabled) {
              const {
                $store: { sessionId: distinctId },
              } = this;
              analytics.identify(distinctId, {
                email: email,
                program: field.dataset.program,
                leadSource: leadSource,
              });
            }
          });

          this.$refs['payment-form'].submit();
        },

        onError: (error) => {
          // E.g. popup is visible, then you immediately close it
          if (error.message === 'Detected popup close') {
            return;
          }

          console.log(error);
          analytics.track('Checkout Validation Failure');
          this.$dispatch(
            'flash-message',
            'An error has occurred. Please try again or contact support.'
          );
        },
      })
      .render(`#${buttonId}`);
  },

  formatOrderData() {
    this.amount = 0;
    let items = [];
    document.querySelectorAll('.plan_ids').forEach((field) => {
      if (!field.disabled) {
        let amount = parseFloat(field.dataset.amount);
        this.amount += amount;

        items.push({
          name: field.dataset.description,
          quantity: 1,
          unit_amount: { currency_code: 'USD', value: amount },
          sku: field.dataset.planId,
        });
      }
    });

    if (this.userEmail) {
      items.push({
        name: 'Gift for ' + this.userEmail,
        quantity: 1,
        unit_amount: { currency_code: 'USD', value: 0 },
      });
    }

    if (this.leadSource && this.leadSource.length > 0) {
      items.push({
        name: 'Lead source: ' + this.leadSource,
        quantity: 1,
        unit_amount: { currency_code: 'USD', value: 0 },
      });
    }

    return {
      intent: 'authorize',
      purchase_units: [
        {
          description: '',
          amount: {
            currency_code: 'USD',
            value: this.amount,
            breakdown: { item_total: { currency_code: 'USD', value: this.amount } },
          },
          items: items,
        },
      ],
    };
  },

  parseAuthorizationResponse(response) {
    const {
      payer: {
        name: { given_name: firstName, surname: lastName },
        email_address: email,
      },
      purchase_units: [purchaseUnit],
    } = response;

    const {
      payments: {
        authorizations: [authorization],
      },
    } = purchaseUnit;

    const { id: authorizationId } = authorization;

    return { authorizationId, email, firstName, lastName };
  },
});
